const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "CusName",
    label: "经销商名称",
    columnwidth: 200,
  },
  {
    prop: "Year",
    label: "年份",
    columnwidth: 60,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 100,
  },
  {
    prop: "StatusName",
    label: "状态",
    columnwidth: 100,
  },
  {
    prop: "IsUploadFileName",
    label: "是否上传文件",
    columnwidth: 120,
  },
  {
    prop: "YearQuota",
    label: "全年指标",
    columnwidth: 130,
  },
  {
    prop: "FirstQuarterQuota",
    label: "第一季度指标",
    columnwidth: 130,
  },
  {
    prop: "SecondQuarterQuota",
    label: "第二季度指标",
    columnwidth: 130,
  },
  {
    prop: "ThirdQuarterQuota",
    label: "第三季度指标",
    columnwidth: 130,
  },
  {
    prop: "ForthQuarterQuota",
    label: "第四季度指标",
    columnwidth: 130,
  },
  {
    prop: "JanQuota",
    label: "一月指标",
    columnwidth: 130,
  },
  {
    prop: "FebQuota",
    label: "二月指标",
    columnwidth: 130,
  },
  {
    prop: "MarQuota",
    label: "三月指标",
    columnwidth: 130,
  },
  {
    prop: "AprQuota",
    label: "四月指标",
    columnwidth: 130,
  },
  {
    prop: "MayQuota",
    label: "五月指标",
    columnwidth: 130,
  },
  {
    prop: "JunQuota",
    label: "六月指标",
    columnwidth: 130,
  },
  {
    prop: "JulQuota",
    label: "七月指标",
    columnwidth: 130,
  },
  {
    prop: "AugQuota",
    label: "八月指标",
    columnwidth: 130,
  },
  {
    prop: "SepQuota",
    label: "九月指标",
    columnwidth: 130,
  },
  {
    prop: "OctQuota",
    label: "十月指标",
    columnwidth: 130,
  },
  {
    prop: "NovQuota",
    label: "十一月指标",
    columnwidth: 130,
  },
  {
    prop: "DecQuota",
    label: "十二月指标",
    columnwidth: 130,
  },
  {
    prop: "CreateTime",
    label: "生成日期",
    columnwidth: 170,
  },
  {
    prop: "CreatorName",
    label: "创建人",
    columnwidth: 120,
  },
  {
    prop: "UpdateTime",
    label: "更新日期",
    columnwidth: 130,
  },
  {
    prop: "Operate",
    label: "操作",
    columnwidth: 170,
    fixed: "right",
  },
];
export default headerData;
